import { __assign } from "tslib";
/* I139 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var DailyDeviation = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M20 2v20l-8-4-8 4V2h16zm-5 4h-1.7625l-.1759.183-.8317 1.635-.2615.182H9v2.497h1.6319l.1453.1814L9 14.1817V16h1.7625l.176-.183.8317-1.6351.2615-.1819H15v-2.497h-1.6318l-.1452-.1827L15 7.8182V6z", fillRule: "evenodd" }))));
};
DailyDeviation.displayName = 'DailyDeviation';
export default DailyDeviation;
//# sourceMappingURL=DailyDeviation.js.map